import { Component, inject, Input, OnInit } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton } from '@angular/material/button'
import { MatToolbar } from '@angular/material/toolbar'
import { TranslateModule } from '@ngx-translate/core'
import { ActivatedRoute, Router } from '@angular/router'
import { bufferTime, filter, firstValueFrom, map, Subject } from 'rxjs'
import { UsersService } from '../users.service'
import { AsyncPipe, Location } from '@angular/common'
import { LoggerService } from '../logger.service'

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatIcon, MatIconButton, MatToolbar, TranslateModule, AsyncPipe],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent implements OnInit {
  @Input()
  title = ''

  @Input()
  backButtonLink: string[] | null = null

  router = inject(Router)
  route = inject(ActivatedRoute)
  usersService = inject(UsersService)
  location = inject(Location)
  currentUser$ = this.usersService.currentUser$
  logger = inject(LoggerService)
  callId$ = this.route.paramMap.pipe(map((params) => parseInt(params.get('id')!)))
  clickSubject = new Subject<void>()

  ngOnInit(): void {
    this.clickSubject
      .asObservable()
      .pipe(
        bufferTime(1500),
        filter((events) => events.length >= 2)
      )
      .subscribe(() => this.togglePowerUserMode())
  }

  handleTitleClick() {
    this.clickSubject.next()
  }

  togglePowerUserMode() {
    firstValueFrom(this.callId$).then((callId) => {
      if (Number.isNaN(callId)) {
        this.router.navigate(['/app', 'admin', 'meetings'], {})
      } else {
        this.router.navigate(['/app', 'admin', 'meetings', callId], {})
      }
    })
  }

  goBack() {
    if (document.referrer === '') {
      this.logger.debug('No referrer found, redirecting to calls')
      this.router.navigate(this.backButtonLink!)
      return
    }
    this.logger.debug(`Referer found. Going back to ${document.referrer}`)
    this.location.back()
  }
}
